// Em produção, desliga console.log/debug/info (warn e error continuam ativos).
// Importado na primeira linha do index.tsx para valer também nos logs de topo de módulo.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {}
  console.log = noop
  console.debug = noop
  console.info = noop
}

export {}
